import {theme} from "@common/theme/theme";

export const studentsConstants = {
    CHANGE_LIST_SURVEY: 'CHANGE_LIST_SURVEY',
    START_AVATAR_GENERATION: 'START_AVATAR_GENERATION',
    STOP_AVATAR_GENERATION: 'STOP_AVATAR_GENERATION',
}

export const avatarColors = [
    theme.colors.lightMore,
    theme.colors.purpleLight,
    theme.colors.primaryLighter,
    theme.colors.accentLighter,
    theme.colors.warningLight,
    theme.colors.linkLighter,
    theme.colors.successLight,
    theme.colors.gemsLight,
]

// Jours de prélèvement proposés — la même liste que la validation serveur
// (`CollectionDay::PUBLIC_DAYS`).
export const PAYMENT_COLLECTION_DAYS = [1, 3, 5, 7, 9, 11, 13]

/** Jour de prélèvement → « 1er » / « 9 », pour « le 1er de chaque mois ». */
export const formatCollectionDay = (day) =>
    Number(day) === 1 ? "1er" : String(day)
